
interface OvertimeInfoProps {
  hours: number;
  charges: number;
}

const OvertimeInfo = ({ hours, charges }: OvertimeInfoProps) => {
  if (hours <= 0) return null;

  return (
    <div className="mt-2 p-2 bg-red-50 rounded-md">
      <p className="text-sm text-red-600">
        Overtime: {hours} hour(s)
      </p>
      <p className="text-sm text-red-600">
        Additional Charges: ₹{charges}
      </p>
    </div>
  );
};

export default OvertimeInfo;
